import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  title: {
    color: '$colorTextOpacity',
  },
  rowContent: {
    color: '$colorText',
  },
});
